<form [formGroup]="form">
	<mat-form-field fxFlex>
		<mat-label>{{label}}</mat-label>
		<input (change)="select($event?.target?.value)" (blur)="onBlur()" [matAutocomplete]="auto" [placeholder]="placeholder"
			   [required]="required" formControlName="search"
			   matInput type="text">
		<mat-error *ngIf="form.get('search')?.hasError('required')">
			{{label}} is required
		</mat-error>
		<mat-error *ngIf="form.get('search')?.hasError('maxlength')">
			Maximum field length is {{maxLength}} characters.
		</mat-error>
		<mat-hint *ngIf="(warnReferenceMask && placeholder.length > 0) &&
						  form?.get('search')?.value?.length !== requiredTextLength" class="warn">
			{{'placeOrderView.maskLengthDoesNotMatchText' | translate}} ({{requiredTextLength}})
		</mat-hint>
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event?.option?.value)"
						  autoActiveFirstOption>
			<mat-option *ngFor="let option of filteredOptions | async" [value]="option">
				{{option}}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</form>
